import React, { useState } from 'react'
import { DeleteModal } from './Dialog'
import { Dropdown, Tooltip, Select } from "antd"
import Loading from './Loading';
import { useDispatch } from 'react-redux';
import { handleDeleteClassActivityForClasses } from 'store/classActivities/thunks';
import { useCurrentClass } from 'store/classes/selectors';
import { handleDeleteGoogleAssignment } from 'store/googleClassRoom/thunks';
import { handleDeleteCanvasAssignment } from 'store/canvas/thunks';
import { IconButton } from '@mui/material';
import { useCurrentUser } from 'store/users/selectors';
import { handleDeleteClassQuizForClasses } from 'store/classQuizzes/thunks';
import { handleDeleteSchoologyAssignment } from 'store/schoology/thunks';
import { useCollectionNotification } from 'utils/methods/firebaseNotification';
import { v4 } from 'uuid';
import moment from 'moment';
import { get, filter } from 'lodash';
import { useClassUsers } from 'store/userClasses/selectors';
import * as Sentry from '@sentry/react';
import trashIconSvg from "../utils/assets/images/trashIcon.svg";
import SentryWrap from 'components/Sentry';
export default function DeleteAssignment({ onDeleteAssignment , deleteLoading, isCustomAssignment  , data}) {
    const [deleteModal, setDeleteModal] = useState(false);
    const [loading, setLoader] = useState(false);
    const [selectedClassIds, setSelectedClassIds] = useState([]);
    const currentUser=  useCurrentUser()
    const currentClass = useCurrentClass()
    const classUsers = useClassUsers()
    const [message, setMessage] = useState(`Are you sure you want to delete? You will lose all submissions and grades for this assignment.`);
    const hasMultipleClasses = data?.classes?.length > 1;
    const dispatch = useDispatch();
    const {createCollectionNotification} = useCollectionNotification();
    const filterClassUsers = filter(classUsers, (user) => user?.role !== 'teacher' && user?.active === true).map(user => user.id);

    const sendNotifications = async (notificationData) => {
        try {
            createCollectionNotification(notificationData, get(currentClass, 'id', ''));
        } catch (error) {
            console.log(error, "error")
            Sentry.captureException(`208 Error during sendNotifications ${error}.`);
        }
    }

    const classIdsToDelete = hasMultipleClasses ? selectedClassIds : (data?.classId ? [data.classId] : (data?.classes?.[0]?.id ? [data.classes[0].id] : []));
    const classAssignmentIdsToDelete = (Array.isArray(data?.classes) ? data.classes : [])
        .filter((cls) => classIdsToDelete.includes(cls?.id))
        .map((cls) => String(cls?.id))
        .filter(Boolean);

    const onDeleteClassAssignment = async () => {
        setLoader(true);
        const idsToDelete = classIdsToDelete.length > 0 ? classIdsToDelete : (data?.classId ? [data.classId] : (data?.classes?.[0]?.id ? [data.classes[0].id] : []));
        let notificationData = {};
        const currentClassInSelection = idsToDelete.includes(get(currentClass, 'id', ''));
        const configAssignment = get(data, 'data.config_assignment') || get(data, 'config_assignment');
        const isEngageAssignment = configAssignment?.isFrom === 'engagement';
        const bookInfo = get(data, 'meta_data.book_info') || get(data, 'data.meta_data.book_info');
        if (currentClass.googleId) {
            await handleDeleteGoogleAssignment(
                currentUser.googleId,
                data?.activityId || data?.quizId,
                classAssignmentIdsToDelete.length > 0
                    ? classAssignmentIdsToDelete
                    : [String(data?.id || data?.data?.id || '')].filter(Boolean)
            );
        }
        if (data && currentClass.sectionId) {
            await handleDeleteSchoologyAssignment(currentUser.schoologyid, data?.activityId || data?.quizId, classAssignmentIdsToDelete);
        }
        
        if (data && currentUser.canvas_id) {
            try {
                await handleDeleteCanvasAssignment(currentUser.canvas_id, data?.activityId || data?.quizId, classAssignmentIdsToDelete, currentUser.canvas_auth_id);
            } catch (error) {
                Sentry.captureException(`209 Error during handleDeleteCanvasAssignment ${error}.`);
            }
        }

        if (data.activityId) {
            await dispatch(handleDeleteClassActivityForClasses(data.activityId, idsToDelete, currentClass.id));
        } else if (data.quizId) {
            await dispatch(handleDeleteClassQuizForClasses(data.quizId, idsToDelete, currentClass.id));
        }

        if (currentClassInSelection) {
            if (data.activityId) {
                notificationData = {
                    id: v4(),
                    classId: get(currentClass, 'id', ''),
                    displayName: get(data, 'displayName', ''),
                    senderId: get(currentUser, 'id', ''),
                    receiversId: filterClassUsers,
                    modified: moment().toISOString(),
                    data: {
                        chapter: get(data, 'data.chapter', ''),
                        page: get(data, 'data.page', ''),
                        id: get(data, 'data.id', ''),
                        ...(bookInfo ? { meta_data: { book_info: bookInfo } } : {}),
                        ...(isEngageAssignment && configAssignment ? { config_assignment: configAssignment } : {}),
                    },
                    message: `Your teacher Delete this Assignment`,
                    type: 'delete_activity',
                    userSeen: [],
                };
            } else if (data.quizId) {
                notificationData = {
                    id: v4(),
                    classId: get(currentClass, 'id', ''),
                    displayName: get(data, 'displayName', ''),
                    senderId: get(currentUser, 'id', ''),
                    receiversId: filterClassUsers,
                    modified: moment().toISOString(),
                    data: {
                        chapter: get(data, 'data.chapter', ''),
                        page: get(data, 'data.page', ''),
                        id: get(data, 'data.id', ''),
                        ...(bookInfo ? { meta_data: { book_info: bookInfo } } : {}),
                        ...(isEngageAssignment && configAssignment ? { config_assignment: configAssignment } : {}),
                    },
                    message: `Your teacher Delete this Quiz`,
                    type: 'delete_quiz',
                    userSeen: []
                };
            }
            sendNotifications(notificationData);
        }

        setDeleteModal(false);
        setLoader(false);
    }
    const onDelete = () => {
        onDeleteClassAssignment();
    }
    const onDeleteActivity = () => {
        onDeleteAssignment();
    }
    const onDeleteClassActivity = () => {
        setMessage(`Are you sure you want to unassign this activity? You will lose all submissions and grades for this assignment.`);
        const currentId = get(currentClass, 'id', null);
        if (currentId) {
            setSelectedClassIds([currentId]);
        } else if (data?.classId) {
            setSelectedClassIds([data.classId]);
        } else if (data?.classes?.[0]?.id) {
            setSelectedClassIds([data.classes[0].id]);
        } else {
            setSelectedClassIds([]);
        }
        setDeleteModal(true);
    }

    const userNav = () => ({
        items: [
            {
                key: 'remove',
                label: 'Remove Activity Assignment',
                onClick: onDeleteClassActivity
            },
            {
                key: 'delete',
                label: 'Delete Activity',
                onClick: onDeleteActivity
            }
        ]
    });
    return (
        <SentryWrap>
            <style>{`
                .delete-assignment-class-select-wrap .ant-select-selector {
                    max-height: 72px !important;
                    overflow-y: auto !important;
                    border: none !important;
                    box-shadow: none !important;
                }
            `}</style>
            <DeleteModal
            message={message}
            deleteToggle={deleteModal}
            setDeleteToggle={setDeleteModal}
            loading={deleteLoading || loading}
            onDelete={onDelete}
            disableConfirm={hasMultipleClasses && selectedClassIds.length === 0}
            extraContent={hasMultipleClasses && data?.classes?.length > 0 ? (
                <div style={{ marginTop: 16, width: '100%', textAlign: 'left' }}>
                    <div style={{ marginBottom: 8, fontSize: 12, fontWeight: 500 }}>Select classes to remove assignment from:</div>
                    <div className="delete-assignment-class-select-wrap" style={{ maxHeight: 96, overflowY: 'auto', borderRadius: 6, border: '1px solid #d9d9d9', padding: '2px 11px 2px 4px', background: '#fff' }}>
                    <Select
                        variant="borderless"
                        mode="multiple"
                        placeholder="Choose classes to unassign"
                        value={selectedClassIds}
                        onChange={setSelectedClassIds}
                        options={data.classes.map((cls) => ({ value: cls.id, label: cls.displayName || cls.name || cls.id }))}
                        style={{ width: '100%' }}
                        maxTagCount={2}
                        className="delete-assignment-class-select"
                        maxTagPlaceholder={(omittedValues) => (
                            <span
                                style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    padding: '2px 8px',
                                    margin: '2px 4px 2px 0',
                                    background: '#e6f4ff',
                                    border: '1px solid #91caff',
                                    borderRadius: 6,
                                    fontSize: 12,
                                    color: '#1677ff',
                                    cursor: 'default',
                                    fontWeight: 500
                                }}
                            >
                                + {omittedValues.length} more
                            </span>
                        )}
                        optionRender={(option) => (
                            <div
                                style={{
                                    whiteSpace: 'normal',
                                    wordBreak: 'break-word',
                                    lineHeight: 1.4,
                                    padding: '2px 0'
                                }}
                            >
                                {option.data?.label ?? option?.label ?? ''}
                            </div>
                        )}
                        tagRender={({ label, value, closable, onClose }) => (
                            <span
                                title={label}
                                style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: 4,
                                    padding: '2px 8px',
                                    margin: '2px 4px 2px 0',
                                    background: '#f0f5ff',
                                    border: '1px solid #adc6ff',
                                    borderRadius: 6,
                                    fontSize: 12,
                                    maxWidth: 160,
                                    boxSizing: 'border-box'
                                }}
                            >
                                <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', minWidth: 0 }}>{label}</span>
                                {closable && (
                                    <span
                                        role="button"
                                        tabIndex={0}
                                        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') onClose(); }}
                                        onClick={onClose}
                                        style={{ cursor: 'pointer', color: '#597ef7', fontWeight: 600, lineHeight: 1 }}
                                        aria-label={`Remove ${label}`}
                                    >
                                        ×
                                    </span>
                                )}
                            </span>
                        )}
                        listHeight={280}
                        dropdownStyle={{ zIndex: 9999, minWidth: 320 }}
                        dropdownAlign={{ overflow: { adjustX: true, adjustY: true } }}
                        dropdownRender={(menu) => (
                            <>
                                <div
                                    style={{
                                        padding: '8px 12px',
                                        borderBottom: '1px solid #f0f0f0',
                                        cursor: 'pointer',
                                        fontSize: 12,
                                        fontWeight: 500,
                                        color: '#1890ff'
                                    }}
                                    onClick={() => setSelectedClassIds(
                                        selectedClassIds.length === data.classes.length
                                            ? []
                                            : data.classes.map((c) => c.id)
                                    )}
                                >
                                    {selectedClassIds.length === data.classes.length ? 'Clear all' : 'Select all'}
                                </div>
                                {menu}
                            </>
                        )}
                        notFoundContent={<span style={{ padding: 8, color: '#888' }}>No classes found</span>}
                    />
                    </div>
                    {selectedClassIds.length > 0 && (
                        <div style={{ marginTop: 6, fontSize: 11, color: '#666' }}>
                            {selectedClassIds.length} class{selectedClassIds.length !== 1 ? 'es' : ''} selected — assignment will be removed from these only
                        </div>
                    )}
                </div>
            ) : null}
        />
        {isCustomAssignment ? <>
            <Dropdown disabled={loading || deleteLoading} className='print-lession-plan' menu={userNav()} placement="bottomCenter"   trigger={['click']} >
                <IconButton aria-label="print" onClick={e => e.preventDefault()} style={{ padding: 0, color: "white" }} >
                    {loading || deleteLoading ? <Loading size={20} /> : 
                      <img src={trashIconSvg} className='trashIcon' alt="" title="" />
                    }
                </IconButton>
            </Dropdown>
        </> : <>
            <IconButton
                color='error'
                style={{ padding: 0 }}
                onClick={onDeleteClassActivity}
            >
                  <img src={trashIconSvg} className='trashIcon' alt="" title="" />
            </IconButton>
        </>}
        </SentryWrap>
    )
}
